import { memo, useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@mui/material'
import InnerTab from './Tab'
import Table from './Table'
import Card from './Card'
import FilterPopover from '../../dataGrid/FilterPopover'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import WelCome from '../../../pages/onboarding/NewWeddingModal/WelCome'
import WeddingName from '../../../pages/onboarding/NewWeddingModal/WeddingName'
import WeddingDate from '../../../pages/onboarding/NewWeddingModal/WeddingDate'
import styles from './index.module.scss'
import Partner from '../../../pages/onboarding/NewWeddingModal/Partner'
import Planning from '../../../pages/onboarding/NewWeddingModal/Planning'
import WeddingPlanner from '../../../pages/onboarding/NewWeddingModal/WeddingPlanner'
import PlanningSupport from '../../../pages/onboarding/NewWeddingModal/PlanningSupport'
import Budget from '../../../pages/onboarding/NewWeddingModal/Budget'
import Guests from '../../../pages/onboarding/NewWeddingModal/Guests'
import GuestsTravel from '../../../pages/onboarding/NewWeddingModal/GuestsTravel'
import ColorScheme from '../../../pages/onboarding/NewWeddingModal/ColorScheme'
import WeddingTheme from '../../../pages/onboarding/NewWeddingModal/WeddingTheme'
import CeremonyVenue from '../../../pages/onboarding/NewWeddingModal/CeremonyVenue'
import VenueAddress from '../../../pages/onboarding/NewWeddingModal/VenueAddress'
import CeremonyVibe from '../../../pages/onboarding/NewWeddingModal/CeremonyVibe'
import ReceptionVenue from '../../../pages/onboarding/NewWeddingModal/ReceptionVenue'
import ReceptionVibe from '../../../pages/onboarding/NewWeddingModal/ReceptionVibe'
import Dinner from '../../../pages/onboarding/NewWeddingModal/Dinner'
import Food from '../../../pages/onboarding/NewWeddingModal/Food'
import Cultural from '../../../pages/onboarding/NewWeddingModal/Cultural'
import CulturalSignificances from '../../../pages/onboarding/NewWeddingModal/CulturalSignificances'
import CaptureYourDay from '../../../pages/onboarding/NewWeddingModal/CaptureYourDay'
import ShareInvitations from '../../../pages/onboarding/NewWeddingModal/ShareInvitations'
import LiveMusic from '../../../pages/onboarding/NewWeddingModal/LiveMusic'
import { formatCommonDate } from '../../../util/formatDateAndTime'

const initialState = {
	partner1: {
		partnerName: '',
		// designation: '',
		email: '',
		sentInvite: false,
	},
	partner2: {
		partnerName: '',
		// designation: '',
		email: '',
		sentInvite: false,
	},
	role: 'Wedding Planner',
	kazooName: '',
	startDate: null,
	endDate: null,
	multiDay: false,
	type: '',
	// plannerSupport: '',
	budget: undefined,
	guestCount: 100,
	guestTravelingAfar: '',
	colorScheme: [],
	theme: '',
	ceremonyVenue: '',
	ceremonyEnvision: [],
	ceremonyVibe: [],
	reception: true,
	receptionVenue: '',
	receptionEnvision: [],
	receptionVibe: [],
	dinnerStyle: '',
	foodType: [],
	culturalSignificances: [],
	traditions: [],
	receptionActivities: [],
	captureCount: {
		photography: 0,
		videography: 0,
		contentCreation: 0,
		photobooth: 0,
	},
	specialActivities: [],
	music: '',
	invitationShareMethod: '',
}

const VendorDashboard = ({ data = [], isStaff = false }) => {
	const isSidebarOpen = useSelector((state) => state.sidebar.isSidebarOpen)
	const accountType = useSelector((state) => state.auth.accountType)
	const [weddingData, setWeddingData] = useState(initialState)
	const [open, setOpen] = useState(false)
	const [step, setStep] = useState(0)

	const [innerTab, setInnerTab] = useState(0)
	const [search, setSearch] = useState('')
	const [filterAnchor, setFilterAnchor] = useState(null)
	const [statusFilter, setStatusFilter] = useState([])

	const filteredRows = useMemo(() => {
		const q = search.trim().toLowerCase()
		return data.filter((r) => {
			if (q && !r.name.toLowerCase().includes(q)) return false
			if (statusFilter.length && !statusFilter.includes(r.status))
				return false
			return true
		})
	}, [search, statusFilter, data])

	const openFilter = (e) => setFilterAnchor(e.currentTarget)
	const closeFilter = () => setFilterAnchor(null)
	const clearFilters = () => {
		setStatusFilter([])
	}

	const handleChangeInnerTab = (event, newValue) => {
		setInnerTab(newValue)
	}

	const handleNext = (s) => {
		if (step === steps.length - 1) {
			setWeddingData(initialState)
			handleClose()
		} else {
			setStep((prev) => prev + (s ? s : 1))
		}
	}

	const handleBack = (s) => setStep((prev) => Math.max(prev - (s ? s : 1), 0))

	const handleClose = () => {
		setWeddingData(initialState)
		setOpen(false)
		setStep(0)
	}

	const steps = useMemo(
		() => {
			const allSteps = [
				// Partner steps - only for non-planner accounts
				...(accountType !== 'kazoo-planner' ? [
					<Partner
						weddingData={weddingData}
						setWeddingData={setWeddingData}
						handleNext={handleNext}
						open={open && step === 0}
						handleClose={handleClose}
						handleBack={handleBack}
						index={1}
					/>,
					<Partner
						weddingData={weddingData}
						setWeddingData={setWeddingData}
						handleNext={handleNext}
						open={open && step === 1}
						handleClose={handleClose}
						handleBack={handleBack}
						index={2}
					/>,
				] : []),
				<WeddingName
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 2 : 0)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<WeddingDate
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 3 : 1)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<Planning
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 4 : 2)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<Budget
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 5 : 3)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<Guests
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 6 : 4)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<GuestsTravel
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 7 : 5)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<ColorScheme
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 8 : 6)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<WeddingTheme
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 9 : 7)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<CeremonyVenue
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 10 : 8)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<VenueAddress
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 11 : 9)}
					handleClose={handleClose}
					handleBack={handleBack}
					type="Ceremony"
				/>,
				<CeremonyVibe
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 12 : 10)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<ReceptionVenue
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 13 : 11)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<VenueAddress
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 14 : 12)}
					handleClose={handleClose}
					handleBack={handleBack}
					type="Reception"
				/>,
				<ReceptionVibe
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 15 : 13)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<Dinner
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 16 : 14)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<Food
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 17 : 15)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<Cultural
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 18 : 16)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<CulturalSignificances
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 19 : 17)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<CaptureYourDay
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 20 : 18)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<LiveMusic
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 21 : 19)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
				<ShareInvitations
					weddingData={weddingData}
					setWeddingData={setWeddingData}
					handleNext={handleNext}
					open={open && step === (accountType !== 'kazoo-planner' ? 22 : 20)}
					handleClose={handleClose}
					handleBack={handleBack}
				/>,
			]
			return allSteps
		},
		[open, step, weddingData, accountType]
	)

	return (
		<>
			<div className={styles.pageHeader}>
				<Typography component="h1">Weddings</Typography>
				<div className={styles.right}>
					<div className={styles.date}>
						<img src="/images/calendar_line.svg" alt="calendar" />
						<span>
							{formatCommonDate(new Date().toISOString())}
						</span>
					</div>
					{accountType === 'kazoo-planner' && (
						<div className={styles.right}>
							<ButtonCustom
								id="new-wedding-btn"
								data-cy="kazoo-button"
								variant="default"
								size="lg"
								onClick={() => setOpen(true)}
							>
								+ New Wedding
							</ButtonCustom>
						</div>
					)}
				</div>
			</div>
			<div className={styles.pageMain}>
				{data?.length > 0 ? (
					<>
						<InnerTab
							dataGrid={
								<div
									className={`${styles.pageScreen} ${isSidebarOpen ? styles.sidebarExpand : ''}`}
								>
									{filteredRows.map((item, index) => (
										<Card
											id={item.id}
											statusLabel={item.status}
											key={index}
											image={item.image}
											title={item.name}
											date={item.date}
											budget={item.budget ?? 0}
											description={item.engageCouple}
											onViewDetail={item.viewDetails}
											onAccept={item.accept}
											onReject={item.reject}
											isStaff={isStaff}
											guestCount={item.guestCount}
										/>
									))}
								</div>
							}
							dataList={
								<div>
									<Table rows={filteredRows} />
								</div>
							}
							isStaff={isStaff}
							innerTab={innerTab}
							handleChangeListCalendar={handleChangeInnerTab}
							onClickFilter={openFilter}
							searchQuery={search}
							onSearchChange={setSearch}
						/>
						<FilterPopover
							anchorEl={filterAnchor}
							open={Boolean(filterAnchor)}
							onClose={closeFilter}
							onClear={clearFilters}
							onApply={closeFilter}
							sections={[
								{
									id: 'status',
									title: 'Status',
									options: [
										'Received',
										'Accepted',
										'Rejected',
										'Completed',
									],
									selected: statusFilter,
									onToggle: (val, checked) =>
										setStatusFilter((prev) =>
											checked
												? [...prev, val]
												: prev.filter((x) => x !== val)
										),
								},
							]}
						/>
					</>
				) : (
					<p>No weddings assigned to you yet</p>
				)}
			</div>
			{open && steps[step]}
		</>
	)
}

export default memo(VendorDashboard)
